import { render, staticRenderFns } from "./ZoneLabel.vue?vue&type=template&id=4c6d2803&"
import script from "./ZoneLabel.vue?vue&type=script&lang=ts&"
export * from "./ZoneLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports